// @ts-nocheck
import logger from "@insite/client-framework/Logger";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import React, { FC } from "react";
import { useSelector } from "react-redux";
import { css } from "styled-components";

/* Store Custom Code - Start */
export const styles: ButtonPresentationProps = {
    typographyProps: {
        weight: "bold",
        size: pxToRem(14),
    },
    size: 50,
    css: css`
        ${({ theme }) => theme.button?.primary?.css}

        ${({ theme }) =>
            breakpointMediaQueries(
                theme,
                [
                    css`
                        width: 100%;
                        margin: 0 auto;
                    `,
                    css`
                        width: 50%;
                        margin: 0 0;
                    `,
                    css`
                        width: ${pxToRem(246)};
                        justify-self: flex-start;
                        margin: 0;
                    `,
                    null,
                    null,
                ],
                "min",
            )};
    `,
};
/* Store Custom Code - End */

const SignInToSeePriceButton: FC = () => {
    const history = useHistory();
    const state = useSelector((state: ApplicationState) => {
        return {
            currentLocation: getLocation(state),
            signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
        };
    });

    const signInHandler = () => {
        if (!state.signInUrl) {
            logger.warn("No url was found for SignInPage, defaulting to /SignIn");
            history.push("/MyAccount/SignIn");
        } else {
            const returnUrl = state.currentLocation.pathname + state.currentLocation.search;
            if (returnUrl === "/") {
                history.push(`${state.signInUrl}`);
            } else {
                history.push(`${state.signInUrl}?returnUrl=${encodeURIComponent(returnUrl)}`);
            }
        }
    };

    return (
        <Button {...styles} onClick={signInHandler}>
            {translate("Sign in to see price")}
        </Button>
    );
};

export default SignInToSeePriceButton;
